module.exports = __webpack_public_path__ + "img/partner_dizhenfang.c519be58.png";